import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from 'src/app/main/constants/dims-map-constants';

export const DRY_SPELL_WMTS_BASE_URL = 'https://metwise-geoserver.vassarlabs.com/new-geoserver/';

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK'];

export const MONSOON_BLOCKS: any = {
  14: {
    jun: '14_jun',
    jun_jul: '14_jun_jul',
    jun_jul_aug: '14_jun_jul_aug',
    jun_jul_aug_sep: '14_jun_jul_aug_sep'
  },
  21: {
    jun: '21_jun',
    jun_jul: '21_jun_jul',
    jun_jul_aug: '21_jun_jul_aug',
    jun_jul_aug_sep: '21_jun_jul_aug_sep'
  }
};

export const SEASON_WINDOWS: any = [
  { key: 'jun',             label: 'June',           sub: 'Monsoon onset',    months: 1 },
  { key: 'jun_jul',         label: 'June + July',    sub: 'First two months', months: 2 },
  { key: 'jun_jul_aug',     label: 'June – August', sub: 'Core monsoon',     months: 3 },
  { key: 'jun_jul_aug_sep', label: 'June – Sep',    sub: 'Full season',      months: 4 }
];

//  /**
//  * 2026 is the current in-progress year — only the June and June+July season windows have
//  * data available so far. Years <= 2025 are complete and continue to show all four windows.
//  */
// export const PARTIAL_SEASON_YEAR = 2026;
// export const PARTIAL_SEASON_WINDOW_KEYS: string[] = ['jun', 'jun_jul'];
// export const PARTIAL_SEASON_LABEL_OVERRIDES: { [key: string]: { label: string; sub: string } } = {
//   // jun's label/sub are identical to SEASON_WINDOWS' own defaults above — this entry exists only
//   // so the Info Box dropdown's windowOptions getter (which reads from this same map) drops the
//   // "only" suffix ("June only" -> "June") for 2026, matching the map badge's own June label
//   // never having said "only" to begin with.
//   // jun: { label: 'June', sub: 'Monsoon onset' },
//   jun: { label: 'June', sub: '' },
//   // jun_jul: { label: 'June + 15 July', sub: 'First one and a half months' }
//     jun_jul: { label: 'July', sub: '' }
// };



/**
 * 2026 is the current in-progress year. Its backend layers now follow the same logic as every
 * other year (2016–2025) EXCEPT the June–September (full season) window, whose September 2026
 * data is not yet complete. That single window is temporarily disabled for 2026 only — its map
 * container stays visible (4-map layout, unchanged), but no layer/API request is made for it,
 * and it is hidden from the Season Window dropdown.
 *
 * TODO: remove this restriction once September 2026 data is available — at that point 2026
 * should use the existing June–September layer/logic exactly like prior years, with no further
 * code changes required here.
 */
export const PARTIAL_SEASON_YEAR = 2026;
export const DISABLED_SEASON_WINDOW_KEY = 'jun_jul_aug_sep';

/**
 * The HEATWAVE:Dryspell_Agri_Mask WMS layer (underlying raster:
 * agri_classified_2025_ds14_jun_jul_aug_sep) only exists for 2025's June–September (4th/full
 * season) window — Enable Agri Mask has no effect for any other year or season window, which
 * continue showing the normal ds14/ds21 heatmap exactly as before.
 */
export const AGRI_MASK_YEAR = 2025;
export const AGRI_MASK_SEASON_KEY = 'jun_jul_aug_sep';
// export const PARTIAL_SEASON_WINDOW_KEYS: string[] = ['jun', 'jun_jul'];
// export const PARTIAL_SEASON_LABEL_OVERRIDES: { [key: string]: { label: string; sub: string } } = {
//   // jun's label/sub are identical to SEASON_WINDOWS' own defaults above — this entry exists only
//   // so the Info Box dropdown's windowOptions getter (which reads from this same map) drops the
//   // "only" suffix ("June only" -> "June") for 2026, matching the map badge's own June label
//   // never having said "only" to begin with.
//   // jun: { label: 'June', sub: 'Monsoon onset' },
//   jun: { label: 'June', sub: '' },
//   // jun_jul: { label: 'June + 15 July', sub: 'First one and a half months' }
//     jun_jul: { label: 'July', sub: '' }
// };

export const DS_COLORS: any = {
  0: '#74add1',
  1: '#4dba6e',
  2: '#f4a732',
  3: '#e05a2b',
  4: '#7c1a0a'
};

export const YEAR_RANGE = { min: 2016, max: 2026 };

export const DRY_SPELL_LAYER_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    'State Boundary': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      layeroptions_protocol: 'WFS'
    },
    'District Boundary': {
      source: 'INDIA',
      displayName: 'District',
      name: 'District Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary',
      layeroptions_pane: 'district',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      layeroptions_protocol: 'WFS'
    },
    'State Boundary Labels': {
      source: 'INDIA',
      displayName: 'State Labels',
      name: 'State Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
      crs: 'EPSG4326'
    }
  }
};

export const DRY_SPELL_LEGEND_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    DS_EVENTS_LEGEND: {
      colorValues: [
        { backgroundColor: '#74add1', text: '0 DS Events', textColor: '#000000' },
        { backgroundColor: '#4dba6e', text: '1 DS Event',  textColor: '#000000' },
        { backgroundColor: '#f4a732', text: '2 DS Events', textColor: '#000000' },
        { backgroundColor: '#e05a2b', text: '3 DS Events', textColor: '#000000' },
        { backgroundColor: '#7c1a0a', text: '≥4 DS Events', textColor: '#ffffff' }
      ]
    }
  }
};
